import React from 'react';
import { useEffect} from 'react';
import Header from './Header'
import Navigation from './Navigation'
import './App.css';

const App = () => {
  useEffect(() => {
    // Update the document title using the browser API
    document.title = `Cognito SSO ${process.env.REACT_APP_VERSION}`;
  });
  return (

    <div className="App">
      <React.Fragment>
        <Header></Header>                
        <Navigation></Navigation>     
        
      </React.Fragment>
    </div>

  );
};



export default App;
